import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
  stack: string;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, stack: '' };

  static getDerivedStateFromError(error: Error): State {
    return { error, stack: '' };
  }

  componentDidCatch(error: Error, info: any) {
    const stack = info?.componentStack || '';
    this.setState({ stack });
    console.error('[ErrorBoundary]', error, stack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-6 text-sm">
          <div className="text-red-600 font-semibold mb-2">页面渲染出错</div>
          <div className="text-muted mb-2 break-all">{this.state.error.message}</div>
          <pre className="text-xs text-muted whitespace-pre-wrap max-h-64 overflow-auto bg-background p-3 rounded-sm border border-border">{this.state.stack}</pre>
          <button
            className="mt-3 rounded-sm border border-border px-3 py-1.5 text-ink hover:bg-background"
            onClick={() => this.setState({ error: null, stack: '' })}
          >
            重试
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
